import { Edit, Remove } from "@app/components/Actions";
import pathRoutes from "../../../../routes/pathRoutes";
import { useMasterTables } from "../useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsReagents = (keysTables: string[], tableName: string) => [
  {
    field: "id",
    headerName: "id",
    headerAlign: "center",
    align: "left",
    flex: 0,
  },
  {
    field: "name",
    headerName: "Nombre",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "number_lot",
    headerName: "Numero de lote",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "reactive_number",
    headerName: "Numero reactivo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "concentration",
    headerName: "Concentración",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "start_date_use",
    headerName: "Fecha inicio",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "end_date_use",
    headerName: "Fecha fin",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
